import { useEffect, useRef, useState } from "react";

const LoadingCard = ({ message, subMessage, showProgress = true, progress }) => {
  const [autoProgress, setAutoProgress] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!showProgress || typeof progress === "number") return undefined;
    intervalRef.current = setInterval(() => {
      setAutoProgress((prev) => {
        if (prev >= 90) return prev;
        const next = prev + Math.floor(Math.random() * 6) + 3;
        return Math.min(next, 90);
      });
    }, 400);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [progress, showProgress]);

  const safeProgress =
    typeof progress === "number"
      ? Math.min(100, Math.max(0, Math.round(progress)))
      : autoProgress;

  return (
    <div className="mx-auto flex w-full max-w-xl items-center justify-center rounded-2xl border border-violet-200 bg-white/95 p-6 shadow-xl">
      <div className="flex w-full items-center gap-4">
        <div className="relative flex h-14 w-14 items-center justify-center rounded-2xl bg-violet-50">
          <span className="loading loading-spinner loading-md text-violet-600"></span>
          <span className="absolute h-3 w-3 rounded-full bg-violet-400 opacity-60 animate-ping"></span>
        </div>
        <div className="flex-1">
          <div className="text-sm font-semibold text-slate-500">Processing</div>
          <div className="mt-1 text-lg font-semibold text-black">
            {message || "Working on it…"}
          </div>
          {subMessage && (
            <div className="mt-1 text-xs text-slate-500">{subMessage}</div>
          )}
          {showProgress && (
            <div className="mt-4">
              <div className="flex items-center justify-between text-xs text-slate-500">
                <span>Progress</span>
                <span>{safeProgress ?? 0}%</span>
              </div>
              <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-violet-100">
                <div
                  className="h-full rounded-full bg-violet-500 transition-[width] duration-300 ease-out"
                  style={{ width: `${safeProgress ?? 0}%` }}
                ></div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoadingCard;
